import {Component, effect, inject, OnDestroy, signal} from '@angular/core';
import {CookiesConsentService} from "../cookies-consent/services/cookies-consent.service";
import {UiService} from "../../services/ui.service";
import {animate, style, transition, trigger} from "@angular/animations";
import {Product} from "../../../core/models/product";
import {combineLatestWith, filter, Subject, takeUntil} from "rxjs";
import {Router} from "@angular/router";
import {AppStateService} from "../../../core/state/app-state.service";

@Component({
  selector: 'app-dialog-cookies',
  templateUrl: './dialog-cookies.component.html',
  styleUrls: ['./dialog-cookies.component.scss'],
  animations: [
    trigger('cookieDialog', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateY(-50px)'}),
        animate('0.5s ease-in-out', style({opacity: 1, transform: 'translateY(0)'}))
      ]),
      transition(':leave', [
        animate('0.5s ease-in-out', style({opacity: 0, transform: 'translateY(50px)'}))
      ])
    ])
  ],
  standalone: false
})
export class DialogCookiesComponent implements OnDestroy {

  private readonly onDestroy$ = new Subject();
  private cookiesService = inject(CookiesConsentService);
  private appStateService = inject(AppStateService);
  private router = inject(Router);

  showCookies = signal(false);
  timeout?: NodeJS.Timeout;

  constructor() {
    effect(() => {
      const product = this.appStateService.product();
      const embedded = this.appStateService.embedded();

      if (product === Product.UNKNOWN) return;

      if (!this.cookiesService.hasChosenCookiePolicies() && !embedded) {
        this.timeout = setTimeout(() => {
          if (!this.router.url.includes('not-supported')) {
            this.showCookies.set(true);
          } else {
            clearTimeout(this.timeout)
            this.showCookies.set(false);
          }
        }, 2000);
      } else {
        clearTimeout(this.timeout)
        this.showCookies.set(false);
      }
    });
  }

  ngOnDestroy() {
    clearTimeout(this.timeout)
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  onCookieClick(consent: boolean) {
    this.showCookies.set(false);
    if (consent)
      this.cookiesService.acceptCookies();
    else
      this.cookiesService.refuseCookies();
  }

}
